import { createApiClient, sessionAccessToken } from "@shyne/shared/api";
import supabase from "@/lib/supabase";

const apiUrl = import.meta.env.VITE_API_URL;
if (!apiUrl) throw new Error("VITE_API_URL is not set. See apps/core/.env.example.");

export const api = createApiClient({ baseUrl: apiUrl, getToken: sessionAccessToken(supabase.auth) });
